<template>
  <FlotoDropdownPicker
    :value="value"
    as-input
    :options="options"
    :placeholder="$tc('select')"
    class="w-full"
    :allow-clear="false"
    @change="$emit('change', $event)"
  >
    <template v-slot:menu-item="{ item: option, selectItem }">
      <div
        class="dropdown-item flex items-center"
        @click.stop="selectItem(option)"
      >
        <span class="ml-2 text-ellipsis" style="display: block">
          {{ option.name }}
        </span>
      </div>
    </template>
  </FlotoDropdownPicker>
</template>

<script>
import { getEnabledLanguagesApi } from '@modules/support-console/api/language-preference-api'
import { LANGUAGE_MAP } from '@utils/language-map'

export default {
  name: 'FlotoLanguageSelector',
  model: {
    event: 'change',
  },
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      options: [],
      lang: this.value,
    }
  },

  created() {
    getEnabledLanguagesApi().then((data) => {
      this.options = data.map((o) => {
        const lang = LANGUAGE_MAP[o.key]
        return {
          name: o.value,
          text: o.value,
          value: o.key,
          key: o.key,
          flagKey: lang,
        }
      })
    })
  },
}
</script>
